<template>
    <div>
        <h4 class="p-2">Asignar becas masiva</h4>
        <form autocomplete="off" @submit.prevent="getAsinarBecasMasiva()">
            <vs-row>
                <vs-col sm="12" lg="3">
                    <filtro-institucion @filtroPadre="getFiltros" :errorFields="errorFields"></filtro-institucion>
                </vs-col>
                <vs-col sm="12" lg="3">
                    <filtro-ciclo-escolar @filtroPadre="getFiltros" :institucion="institucion"  :errorFields="errorFields"></filtro-ciclo-escolar>
                </vs-col>
                <vs-col sm="12" lg="3">
                    <filtro-grupo @filtroPadre="getFiltros" :institucion="institucion" :cicloEscolar="cicloEscolar" :errorFields="errorFields"></filtro-grupo>
                </vs-col>
                <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                    <vs-button
                    >
                        <i class="fas fa-search mr-2"></i>Buscar
                    </vs-button>
                </vs-col>
            </vs-row>
        </form>
        <tabla-asignar-becas :becas="becas" :institucion="institucion" :cicloEscolar="cicloEscolar" :grupo="grupo" @refreshTabla="getAsinarBecasMasiva"></tabla-asignar-becas>
    </div>
</template>
<script>
import FiltroInstitucion from '../../filtros/institucion.vue'
import FiltroCicloEscolar from '../../filtros/ciclo-escolar.vue'
import FiltroGrupo from '../../filtros/grupo.vue'
import TablaAsignarBecas from './tabla-asignar-becas.vue'
import servicios from '../../../../api/requests/servicios'
export default {
    data(){
        return{
            institucion: '',
            cicloEscolar: '',
            grupo: '',
            tipo: '',
            errorFields: [],
            becas: []
        }
    },
    components:{
        FiltroInstitucion,
        FiltroCicloEscolar,
        FiltroGrupo,
        TablaAsignarBecas
    },
    methods:{
        getFiltros(id, tipo){
            if(tipo == 'institucion'){
                this.institucion = id
            }
            if(tipo == 'cicloEscolar'){
                this.cicloEscolar = id
            }
            if(tipo == 'grupo'){
                this.grupo = id
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.grupo) {
                this.errorFields.push('grupo')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async getAsinarBecasMasiva(){
            if(this.sanityForm()){
                const loading = this.$vs.loading({
                    text: 'Favor espere, esto podría tardar un poco.'
                })
                try{
                    const params = {
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                        grupo_id: this.grupo
                    }
                    const { data: response} = await servicios.getAsinarBecasMasiva(params)
                    this.becas = response.data
                    loading.close()
                }catch(error){
                    console.log(error)
                    loading.close()
                }
                
            }
        }
    }
}
</script>
